import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { collapsedResultsSelector } from './selectors';
import { Wrapper, Header, Cell, GridColumn } from './styled';

const CollapsedGrid = props => {
  const { standardId } = props;

  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);
  const standards = useSelector(state => state.entitiesReducer.standards);
  const { childTopics: learningJourneyIds = [] } = standards[standardId] || {};
  const results = useSelector(collapsedResultsSelector(sortedStudentIds, learningJourneyIds));

  return (
    <Wrapper>
      <Header />
      <GridColumn>
        {results.map(result => {
          const { id, value, showResult } = result;

          return <Cell key={id}>{showResult && value} </Cell>;
        })}
      </GridColumn>
    </Wrapper>
  );
};

CollapsedGrid.propTypes = {
  standardId: PropTypes.number.isRequired
};

export default CollapsedGrid;



// WEBPACK FOOTER //
// ./components/grid/collapsed/index.js